<template>
  <div>
    <b-modal id="deleteModal" v-model="modalShow" title="査定見積の削除">
      <!-- <p class="mb-0">
        査定が途中のものがあります。<br />このエアコンの査定を中断して、取付依頼に進みますか？<br />この操作は取り消すことができません。
      </p> -->
      <template #modal-footer>
        <b-button variant="link" @click="modalShow = false">
          キャンセル
        </b-button>
        <!-- <b-button variant="primary" @click="removeEstimation">
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 512 512"
            class=""
          >
            <path
              fill="currentColor"
              d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
              class=""
            ></path>
          </svg>
          取付依頼に進む
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      modalShow: false,
      estimateIndex: null,
    };
  },
  methods: {
    ...mapActions({
      doRemoveCurrentEstimation: "doRemoveCurrentEstimation",
    }),
    show() {
      this.modalShow = true;
    },
    removeEstimation() {
      this.doRemoveCurrentEstimation();
      this.modalShow = false;
      this.$router.push({ name: "page2" });
    },
  },
};
</script>